import React from "react";

export default function DrawRequestIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="1"
        width="12"
        height="12"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
      />
      <line
        x1="4"
        y1="5"
        x2="10"
        y2="5"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <line
        x1="4"
        y1="7.5"
        x2="10"
        y2="7.5"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <line
        x1="4"
        y1="10"
        x2="7"
        y2="10"
        stroke="currentColor"
        strokeWidth="1.1"
      />
    </svg>
  );
}
